import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isSearchInputOpen: false,
    isSearchResultOpen: false,
    isFilterPanelOpen: false,
    isPopinOpen: false,
    isLotPanelOpen: false,
    activeFilter: null,
    activeLot: null,
    activeLinkedLot: null,
    searchQuery: null,
    activeMarker: null,
    urlHash: null,
    mapMarkers: null,
    investigations: null,
    themes: null
  },
  mutations: {
    setIsSearchInputOpen (state, value) {
      state.isSearchInputOpen = value
    },
    setIsSearchResultOpen (state, value) {
      state.isSearchResultOpen = value
    },
    setIsFilterPanelOpen (state, value) {
      state.isFilterPanelOpen = value
    },
    setIsPopinOpen (state, value) {
      state.isPopinOpen = value
    },
    setIsLotPanelOpen (state, value) {
      state.isLotPanelOpen = value
    },
    setActiveFilter (state, value) {
      state.activeFilter = value
    },
    setActiveLot (state, value) {
      state.activeLot = value
    },
    setActiveLinkedLot (state, value) {
      state.activeLinkedLot = value
    },
    setSearchQuery (state, value) {
      state.searchQuery = value
    },
    setActiveMarker (state, value) {
      state.activeMarker = value
    },
    setUrlHash (state, value) {
      state.urlHash = value
    },
    setMapMarkers (state, value) {
      state.mapMarkers = value
    },
    setThemes (state, value) {
      state.themes = value
    },
    setInvestigations (state, value) {
      state.investigations = value
    }
  },
  actions: {
    setIsSearchInputOpen ({ commit }, value) {
      commit('setIsSearchInputOpen', value)
    },
    setIsSearchResultOpen ({ commit }, value) {
      commit('setIsSearchResultOpen', value)
    },
    setIsFilterPanelOpen ({ commit }, value) {
      commit('setIsFilterPanelOpen', value)
    },
    setIsPopinOpen ({ commit }, value) {
      commit('setIsPopinOpen', value)
    },
    setIsLotPanelOpen ({ commit }, value) {
      commit('setIsLotPanelOpen', value)
    },
    setActiveFilter ({ commit }, value) {
      commit('setActiveFilter', value)
    },
    setActiveLot ({ commit }, value) {
      commit('setActiveLot', value)
    },
    setActiveLinkedLot ({ commit }, value) {
      commit('setActiveLinkedLot', value)
    },
    setSearchQuery ({ commit }, value) {
      commit('setSearchQuery', value)
    },
    setActiveMarker ({ commit }, value) {
      commit('setActiveMarker', value)
    },
    setUrlHash ({ commit }, value) {
      commit('setUrlHash', value)
    },
    setMapMarkers ({ commit }, value) {
      commit('setMapMarkers' +
        '', value)
    },
    setThemes ({ commit }, value) {
      commit('setThemes', value)
    },
    setInvestigations ({ commit }, value) {
      commit('setInvestigations', value)
    }
  },
  getters: {
    investigations (state) {
      return state.investigations
    },
    themes (state) {
      return state.themes
    }
  },
  modules: {
  }
})
